import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useExpertReportRuleCommentHistory } from '@/entities/expert-report';
import { HistoryDialog } from '@/shared/ui';
import { EvaluationRuleCommentVersion } from './EvaluationRuleCommentVersion';

type Props = {
  conversationId: number;
  expertReportId: number;
  ruleId: number;
  /** Блок правила: ссылки в тексте версий открывают правило и знание этого блока */
  blockId: number;
};

/**
 * История версий комментария правила: комментарии, составленные системой при каждом расчёте,
 * и правки пользователей — от свежих к старым.
 *
 * Открыта каждому, кто видит диалог, — правка комментария тут ни при чём.
 */
export const EvaluationRuleCommentHistory: FC<Props> = ({ conversationId, expertReportId, ruleId, blockId }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <HistoryDialog
      title={t('dialogs:expertReport.commentHistory')}
      emptyText={t('dialogs:expertReport.commentHistoryEmpty')}
      useHistory={useExpertReportRuleCommentHistory}
      params={{ conversationId, expertReportId, ruleId }}
      getItemKey={(version) => `${version.createdAt}-${version.source}`}
      renderItem={(version) => (
        <EvaluationRuleCommentVersion version={version} expertReportId={expertReportId} blockId={blockId} />
      )}
    />
  );
};
